import { decamelizeKeys } from 'humps'
import decode from 'jwt-decode'
import { merge } from 'lodash'

import * as eventNames from './event-names'
import AliadaAnalytics from '@src/services/aliada-analytics'
import { getAuthToken } from 'utils/auth'

const DEFAULT_CONFIG = {
  debug: process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default class Analytics {
  constructor (config = {}) {
    this.config = merge({}, DEFAULT_CONFIG, config)
    this.aliada = new AliadaAnalytics({ debug: this.config.debug })

    this._init()
  }

  _init () {
    // This is necessary because if the user is logged in, and Analytics has
    // never received the login/signup event, we wont know who they is. Therefore,
    // the safest thing to do is identify the user if we have their userId.
    this._initialIdentify()
  }

  _initialIdentify () {
    const getUserId = () => {
      const token = getAuthToken()
      const { user_id: userId } = decode(token)
      return userId
    }

    let userId
    try {
      userId = getUserId()
    } catch (e) {
      return
    }

    this.aliada.register({ userId })
  }

  _track (eventName, eventData) {
    eventData = decamelizeKeys(eventData)
    this.aliada.track(eventName, eventData)
  }

  coloniaSubmit (eventData) {
    this._track(eventNames.COLONIA_SUBMIT, eventData)
  }

  coloniaNotFound (eventData) {
    this._track(eventNames.COLONIA_NOT_FOUND, eventData)
  }

  houseSizeSubmit (eventData) {
    this._track(eventNames.HOUSE_SIZE_SUBMIT, eventData)
  }

  preferencesSubmit (eventData) {
    this._track(eventNames.PREFERENCES_SUBMIT, eventData)
  }

  datetimeSubmit (eventData) {
    this._track(eventNames.DATETIME_SUBMIT, eventData)
  }

  searchResults (eventData) {
    this._track(eventNames.SEARCH_RESULTS, eventData)
  }

  aliadaViewSubmit (eventData) {
    this._track(eventNames.ALIADA_VIEW_SUBMIT, eventData)
  }

  aliadaChosenSubmit (eventData) {
    this._track(eventNames.ALIADA_CHOSEN_SUBMIT, eventData)
  }

  addressSubmit (eventData) {
    this._track(eventNames.ADDRESS_SUBMIT, eventData)
  }

  serviceSummarySubmit (eventData) {
    this._track(eventNames.SERVICE_SUMMARY_SUBMIT, eventData)
  }

  login (eventData) {
    const { userId } = eventData
    eventData = decamelizeKeys(eventData)

    this.aliada.register(eventData)
    this.aliada.track(eventNames.LOG_IN)
  }

  signup (eventData) {
    const { userId } = eventData
    eventData = decamelizeKeys(eventData)

    this.aliada.register(eventData)
    this.aliada.track(eventNames.SIGN_UP)
  }

  paymentTokenGenerationSuccess (eventData) {
    this._track(eventNames.PAYMENT_PROVIDER_TOKEN_GENERATION_SUCCESS, eventData)
  }

  paymentTokenGenerationFailure (eventData) {
    this._track(eventNames.PAYMENT_PROVIDER_TOKEN_GENERATION_FAILURE, eventData)
  }

  serviceConfirmationSuccess (eventData) {
    this._track(eventNames.SERVICE_CONFIRMATION_SUCCESS, eventData)
  }

  serviceConfirmationFailure (eventData) {
    this._track(eventNames.SERVICE_CONFIRMATION_FAILURE, eventData)
  }
}



// WEBPACK FOOTER //
// ./src/services/Analytics/Analytics.js